import { render, staticRenderFns } from "./DefaultContent-Order.vue?vue&type=template&id=0cee8274&"
import script from "./DefaultContent-Order.vue?vue&type=script&lang=js&"
export * from "./DefaultContent-Order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports